/* =========================================================================
   CHARMANTE — Panier (branché sur le VRAI panier Shopify, en AJAX)
   - Ajout au panier sans rechargement (intercepte les formulaires /cart/add)
   - Met à jour le badge de l'en-tête
   - Expose window.Charmante.cart.subtotal()/count() + émet « cart:change »
     → la jauge livraison gratuite (charmante-freeship.js) reste synchronisée
   - Joue le petit projectile vers l'icône panier (si dispo)
   ========================================================================= */
(function () {
  'use strict';
  var C = (window.Charmante = window.Charmante || {});

  function badgeEl() { return document.querySelector('[data-cart-count]'); }
  function setBadge(n) {
    var b = badgeEl(); if (!b) return;
    b.textContent = n;
    b.style.display = n > 0 ? '' : 'none';
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function apply(cart, opts) {
    opts = opts || {};
    C.cartState = cart;
    setBadge(cart.item_count);
    if (!opts.deferGauge) document.dispatchEvent(new CustomEvent('cart:change'));   // pour la jauge
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    return cart;
  }

  // ----- Ajout au panier en AJAX (intercepte tous les formulaires d'ajout) -----
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    // Feedback INSTANTANÉ : les cœurs + le toast partent tout de suite, sans attendre le serveur
    if (typeof C.flyToCart === 'function' && btn) { try { C.flyToCart(btn); } catch (e2) {} }
    var pop = document.getElementById('fspop'); if (pop) pop.hidden = true;
    if (typeof C.toast === 'function') C.toast('Ajouté au panier ✨');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return getCart(); })
      .then(function (cart) {
        apply(cart, { deferGauge: true });                 // maj badge + état en arrière-plan
        // la jauge « Livraison gratuite » apparaît APRÈS la disparition du toast
        setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:change')); }, 2200);
      })
      .catch(function () { form.submit(); })   // repli : ajout classique avec rechargement
      .then(function () { if (btn) btn.disabled = false; });
  });

  function boot() { getCart().then(apply).catch(function () {}); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  C.cart = {
    get: getCart,
    refresh: boot,
    // +1 OPTIMISTE : le badge bouge TOUT DE SUITE au clic (pas d'attente réseau) ; le vrai total réconcilie au refresh suivant.
    bump: function (n) {
      n = n || 1;
      var cur = (C.cartState && typeof C.cartState.item_count === 'number')
        ? C.cartState.item_count
        : (parseInt((badgeEl() && badgeEl().textContent) || '0', 10) || 0);
      var next = cur + n;
      if (C.cartState) C.cartState.item_count = next;   // garde count() cohérent en attendant le refresh
      setBadge(next);
    },
    subtotal: function () { return C.cartState ? C.cartState.total_price / 100 : 0; },  // en €
    count: function () { return C.cartState ? C.cartState.item_count : 0; }
  };
})();
